import './style.scss';

export const TextUseFiltros = () => {
	return (
		<div className="centered-message">
			<p>¡Utiliza los filtros para encontrar lo que buscas más rápido!</p>
		</div>
	);
};
